export const ConversationFilterStatus = [
  {name: "باز (OPEN)", value: 0},
  {name: "بسته (CLOSE)", value: 1},
];
export const ConversationFilterProducts = [
  {name: "کرفس (KARAFS)", value: "KARAFS"},
  {name: "لونا (LUNA)", value: "LUNA"},
  {name: "بنتو (BENTO)", value: "BENTO"},
  {name: "دنج (DENJ)", value: "DENJ"},
  {name: "جیم (GYM)", value: "GYM"},
];

export const ConversationFilterTags = [
  {name: "(INDELIBLE) غیر قابل پاک شدن", value: "INDELIBLE"},
  {name: "(CONVERSATION_WITH_SUPPORT) مکالمه با پشتیبانی", value: "CONVERSATION_WITH_SUPPORT"},
  {name: "(FORUM) فروم", value: "FORUM"},
  {name: "(CONVERSATION_WITH_SPECIALIST) مکالمه با متخصص", value: "CONVERSATION_WITH_SPECIALIST"},
  {name: "(USER_WITH_USER) کاربر با کاربر", value: "USER_WITH_USER"},
  {name: "(GROUP) گروه", value: "GROUP"},
  {name: "(DISABLED) غیر فعال", value: "DISABLED"},
];

export const ConversationFilterTypes = [
  {name: "(PRIVATE) خصوصی", value: "PRIVATE"},
  {name: "(PUBLIC) عمومی", value: "PUBLIC"},
];

export const ConversationInputTags = [
  {name: "INDELIBLE", id: "INDELIBLE"},
  {name: "CONVERSATION_WITH_SUPPORT", id: "CONVERSATION_WITH_SUPPORT"},
  {name: "FORUM", id: "FORUM"},
  {name: "CONVERSATION_WITH_SPECIALIST", id: "CONVERSATION_WITH_SPECIALIST"},
  {name: "USER_WITH_USER", id: "USER_WITH_USER"},
  {name: "GROUP", id: "GROUP"},
  {name: "DISABLED", id: "DISABLED"},
];

export const ConversationStatus = [
  {name: "باز (OPEN)", id: 0},
  {name: "بسته (CLOSE)", id: 1},
];
